import { graphql } from "gatsby"
import React from "react"

import Carousel from "@organisms/Carousel/Carousel"

const CarouselManual = ({ blockDataCarouselManual }) => {
  const { heading, columns, cards } = blockDataCarouselManual || {}

  const columnCount = parseInt(columns)

  const slides = cards?.map((slide, index) => {
    return {
      title: slide?.link?.title,
      url: slide?.link?.url,
      tagline: slide?.subtitle,
      ...slide,
    }
  })

  return (
    <Carousel
      slides={slides}
      heading={heading}
      columns={[2, 3].includes(columnCount) ? columnCount : 2}
    />
  )
}

export const query = graphql`
  fragment CarouselManual on WpBlockAcfCarouselManual {
    __typename
    blockDataCarouselManual {
      heading
      columns
      cards {
        image {
          mediaDetails {
            width
            height
          }
          cloudinaryDetails {
            public_id
            original_filename
            format
          }
          sourceUrl
          altText
          altTextOriginal
        }
        subtitle
        link {
          url
          title
        }
        cta
      }
    }
  }
`

export default CarouselManual
